import config from '@/api/config';
import _ from 'lodash';

const state = () => ({
	entities: [],
	loaded: false
});

const getters = {};



const mutations = {
	setEntities: (state, entities) => {
		state.entities = entities;
	},
	setLoaded: (state, loaded) => {
		state.loaded = loaded;
	}
};

// Entity lists can be tens of thousands of records, so share one request between callers asking for the same thing
const inflight = {};

const actions = {
	load: async ({commit}, filter) => {
		
		let key, request;
		
		if(filter.integrationId)
		{
			key = `integration:${filter.integrationId}`;
			request = () => config.getEntitiesByIntegration(filter.integrationId);
		} else if(filter.type){
			key = `type:${filter.type}`;
			request = () => config.getEntitiesByType(filter.type);
		} else {
			return;
		}
		
		// fresh: true skips sharing, for reloads that must reflect a write made after an in-flight request began
		if(!inflight[key] || filter.fresh)
		{
			const promise = request().finally(() => {
				if(inflight[key] === promise)
				{
					delete inflight[key];
				}
			});
			inflight[key] = promise;
		}
		
		const entities = await inflight[key];
		
		commit('setEntities', entities);
		commit('setLoaded', true);

	},

	sync: async ({commit}, integrationId) => {
		return config.sync(integrationId);
	}

};


export default {
	namespaced: true,	
	state,
	getters,
	mutations,
	actions
};